import * as api from '../../api/api-solicitud-descuento-modal';
import { 
    GET_CONFIG_FORM17,
    GET_COMBO_MOTIVO_DESCUENTO,
    POST_ACTUALIZAR_SOLICITUD,
    CLEAN_SOLICITUD,
    SET_LOADING_DESCUENTO,
    GET_SOLICITUD_DESCUENTO
   
} from '../types';

export const configuracionFormAction17 = (query) => ({
    type: GET_CONFIG_FORM17,
    payload: api.getConfiguracionForm17(query)
});
export const obtenerComboMotivoDescuento = (query) => ({
    type: GET_COMBO_MOTIVO_DESCUENTO,
    payload: api.getComboMotivoDescuento(query)
});
export const obtenerSolicitudDescuentos = (query) => ({
    type: GET_SOLICITUD_DESCUENTO,
    payload: api.getSolicitudDescuento(query)
});
export const postActualizarSocitud = (query) => ({
    type: POST_ACTUALIZAR_SOLICITUD,
    payload: api.postActualizarSolicitud(query)
});
export const obtenerCleanSolicitud = () => ({
    type: CLEAN_SOLICITUD,
    
});
export const cambiarLoadingDescuento = (loading) => ({
    type: SET_LOADING_DESCUENTO,
    payload:loading
});